import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import CardPaymentInfo from '../components/CardPaymentInfo.js';
import CardBookingInfo from '../components/CardBookingInfo.js';
import Card from '../Card.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["headingLevel", "buttonText", "columnSpan", "image", "imagePosition", "imageWidth", "lazy", "onClick", "rating", "subtitle", "title", "url", "travelType", "durationText", "departureName", "paxText", "room", "leftToPay", "totalPrice", "paymentDetails", "reservedPayments", "onClickTraveldocuments", "onClickDiscountCode"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BookingCard = function BookingCard(_ref) {
  var _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? null : _ref$headingLevel,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? null : _ref$buttonText,
    _ref$columnSpan = _ref.columnSpan,
    columnSpan = _ref$columnSpan === void 0 ? 12 : _ref$columnSpan,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? 'left' : _ref$imagePosition,
    _ref$imageWidth = _ref.imageWidth,
    imageWidth = _ref$imageWidth === void 0 ? 6 : _ref$imageWidth,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$rating = _ref.rating,
    rating = _ref$rating === void 0 ? null : _ref$rating,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? null : _ref$url,
    _ref$travelType = _ref.travelType,
    travelType = _ref$travelType === void 0 ? null : _ref$travelType,
    _ref$durationText = _ref.durationText,
    durationText = _ref$durationText === void 0 ? null : _ref$durationText,
    _ref$departureName = _ref.departureName,
    departureName = _ref$departureName === void 0 ? null : _ref$departureName,
    _ref$paxText = _ref.paxText,
    paxText = _ref$paxText === void 0 ? null : _ref$paxText,
    _ref$room = _ref.room,
    room = _ref$room === void 0 ? null : _ref$room,
    _ref$leftToPay = _ref.leftToPay,
    leftToPay = _ref$leftToPay === void 0 ? 0 : _ref$leftToPay,
    _ref$totalPrice = _ref.totalPrice,
    totalPrice = _ref$totalPrice === void 0 ? 0 : _ref$totalPrice,
    _ref$paymentDetails = _ref.paymentDetails,
    paymentDetails = _ref$paymentDetails === void 0 ? null : _ref$paymentDetails,
    _ref$reservedPayments = _ref.reservedPayments,
    reservedPayments = _ref$reservedPayments === void 0 ? null : _ref$reservedPayments,
    _ref$onClickTraveldoc = _ref.onClickTraveldocuments,
    onClickTraveldocuments = _ref$onClickTraveldoc === void 0 ? null : _ref$onClickTraveldoc,
    _ref$onClickDiscountC = _ref.onClickDiscountCode,
    onClickDiscountCode = _ref$onClickDiscountC === void 0 ? null : _ref$onClickDiscountC,
    rest = _objectWithoutProperties(_ref, _excluded);
  var showButtonInFooter = !!(url || onClick);
  return /*#__PURE__*/jsxs(Card, _objectSpread(_objectSpread({}, rest), {}, {
    columnSpan: columnSpan,
    image: image,
    imagePosition: imagePosition,
    imageWidth: imageWidth,
    lazy: lazy,
    conceptRowText: ""
    // onClick={onClick}
    // url={url}
    ,
    variant: "hotel",
    children: [/*#__PURE__*/jsx(CardBookingInfo
    // bullets={bullets}
    // description={description}
    // guestRating={guestRating}
    // ksps={ksps}
    // linkList={linkList}
    // promotionLabel={promotionLabel}
    // tripadvisorRating={tripadvisorRating}
    , {
      url: url,
      rating: rating,
      subtitle: subtitle,
      travelType: travelType,
      durationText: durationText,
      departureName: departureName,
      paxText: paxText,
      room: room,
      title: title,
      headingLevel: headingLevel
    }), /*#__PURE__*/jsx(CardPaymentInfo
    // leftToPay={}
    // paymentDetailsList={}
    // paymentUrl={}
    // totalPrice={}
    // texts={}
    // siteId={}
    // reservedPayments={}
    // travelType={}
    , {
      onClickTraveldocuments: onClickTraveldocuments,
      onClickDiscountCode: onClickDiscountCode,
      paymentDetails: paymentDetails,
      reservedPayments: reservedPayments,
      totalPrice: totalPrice,
      leftToPay: leftToPay,
      buttonText: buttonText,
      showButton: showButtonInFooter
    })]
  }));
};
var BookingCard$1 = BookingCard;

export { BookingCard$1 as default };
//# sourceMappingURL=BookingCard.js.map
